import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as dayjs from 'dayjs';
import styled from 'styled-components';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Popup } from '@progress/kendo-react-popup';
import { DotsVerticalRounded } from 'styled-icons/boxicons-regular';
import { Close } from 'styled-icons/evil';
import { Done } from 'styled-icons/material';
import PuffLoader from 'react-spinners/PuffLoader';
import Drawer from '@material-ui/core/Drawer';
import { ChevronLeft, MoreVertical } from 'styled-icons/fluentui-system-regular';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { toast } from 'react-toastify';
import { setDocumenteElastic } from '@unis/unis-ats/src/system/utils/axiosHelper';
import production from '@unis/unis-ats/src/system/access/environment';
import { NotificationManager } from 'react-notifications';
import { CompanyCard, UserCard, VacancyCard } from '../../components/dashboard/cards';
import database, { firebase } from '../../model/firebase/firebase';
import { setCompanies } from '../../redux/actions/_companies_actions';
import { acceptUser } from '../../redux/actions/_users_actions';
import { manageVacancy } from '../../redux/actions/_admin_actions';
import CompaniesDashboard from '../../components/dashboard/cards/companyDashboard';
import VacanciesDashboard from '../../components/dashboard/cards/vacancyDashboard';
import UsersDashboard from '../../components/dashboard/cards/userDashboard';
import JobDetailModal from '../../components/dashboard/modals/jobDetails';
import UserDetailModal from '../../components/dashboard/modals/userDetails';
import { fetchDataPostAsync } from '../../model/axios/fetchs';
import { palette } from '../../system/styles/styles';
import CompanyModal from '../../components/dashboard/modals/companyModal';
import { startShowVacancies } from '../../redux/actions/_initializer_actions';
import notfound from '../../assets/not-found.gif';
import { MainStyled } from '../../system/styles/views/dashboard';
import { Box, CircularProgress } from '@material-ui/core';

const MainDashboard = () => {
  const platform = useSelector((state) => state.platform);
  const vacancies = useSelector((state) => state.vacancies);
  const users = useSelector((state) => state.users);
  const companies = useSelector((state) => state.companies);

  const dispatch = useDispatch();

  const [state, setState] = React.useState({
    CurrentTable: 'student',
    vacancies: [],
    users: [],
    companies: [],
    showVacancyModal: false,
    currentVacancy: {
      companyName: '',
      locationName: '',
      data: '',
      jobPay: '',
      jobTitle: '',
      contract: '',
      img: '',
      seniority: '',
      carrer: [],
      isSingleCarrer: true,
      singleCarrer: '',
    },
    showUserModal: false,
    currentUser: {
      names: '',
      lastNames: '',
      email: '',
      scholarID: '',
      currentQuestion: '',
      question: '',
      status: '',
    },
    showCompanyModal: false,
    currentCompany: {
      companyName: '',
      locationName: '',
      data: '',
      companyWebsite: '',
      companyAbout: '',
    },
    openAlert: false,
    vertical: 'top',
    horizontal: 'right',
    message: '',
  });
  const [loader, setLoader] = React.useState({ active: false, action: '' });
  const [loading, setLoading] = React.useState('');
  const [multiAccept, setMultiAccept] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [drawer, setDrawer] = React.useState(false);
  const open = Boolean(anchorEl);

  const toggleDrawer = (bool) => {
    setDrawer(!bool);
  };

  // Metodo para cargar en redux todo lo necesario
  const onLoadMain = () => {
    dispatch(startShowVacancies());
  };

  const handleClick = (event) => {
    const { currentTarget } = event;
    if (!anchorEl) {
      setAnchorEl(currentTarget);
    } else {
      setAnchorEl(null);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const selectAll = () => {
    if (state.CurrentTable === 'student') {
      setMultiAccept([...state.users]);
    } else if (state.CurrentTable === 'vacancy') {
      setMultiAccept([...state.vacancies]);
    } else {
      setMultiAccept([...state.companies]);
    }
    setAnchorEl(null);
  };

  const removeAll = () => {
    setMultiAccept([]);
    setAnchorEl(null);
  };

  const ToggleModal = (name) => {
    setState((prevState) => ({
      ...prevState,
      [name]: false,
    }));
  };

  const showMore = (name, data, modal) => {
    setState((prevState) => ({
      ...prevState,
      [name]: data,
      [modal]: true,
    }));
  };

  const getData = () => {
    const waitingVacancies = vacancies.reduce((acc, element) => {
      if (element.Status && element.Permission === 'waiting') {
        acc.push(element);
        return acc;
      }
      return acc;
    }, []);

    const initUsers = users.reduce((acc, element) => {
      if (element.status === 'init') {
        acc.push(element);
        return acc;
      }
      return acc;
    }, []);

    const activeCompanies = companies.reduce((acc, element) => {
      if (!element.active) {
        acc.push(element);
        return acc;
      }
      return acc;
    }, []);

    setState((prevState) => ({
      ...prevState,
      companies: activeCompanies,
      users: initUsers,
      vacancies: waitingVacancies,
      loadVacancies: false,
    }));
  };

  const bodyMailAccepted = (name, destiny) =>
    platform.customEmails
      ? {
          fromEmail: `${platform.fromEmail}`,
          destiny: `${destiny}`,
          subject: `${name} tu registro se realizó con éxito! - Bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${name},</p>
           <br />
           <p style="font-size: 18px; font-weight: 600; text-align: center">¡Bienvenido a la bolsa de trabajo de ${platform.platformName.toUpperCase()}!</p>
           <br />
           <p style="font-size: 20px;">Ahora puedes acceder a ofertas laborales desde el sitio 
            ${platform.platformURL}, te recordamos que tus datos de acceso (correo electrónico y contraseña) 
            los estableciste al momento de registrarte. Mantenlos en un lugar seguro y no los compartas.</p>
           <br />
           <p style="font-size: 20px;">Este correo se envía una única vez como bienvenida al programa. 
           Conoce más en nuestro Aviso de privacidad publicado en la plataforma. Si tú no eres el 
           destinatario, por favor, elimina el correo electrónico. ®.</p>
           <br />
           <p style="font-size: 20px; font-weight: 600;">Te deseamos mucho éxito.</p>
           <br /> 
           <img width="160px" src=${platform.customEmailsLogo} />
           <br />
           <p style="font-size: 14px;">¿Ya nos sigues?</p>
           <br />
           ${
             platform.facebookLink &&
             `<a styles="margin: 7px" href=${platform.facebookLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                </a>`
           }
           ${
             platform.twitterLink &&
             `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
           }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
        `,
        }
      : {
          destiny: `${destiny}`,
          subject: `${name} tu registro se realizó con éxito! - Bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${name},</p>
           <br />
           <p style="font-size: 18px; font-weight: 600; text-align: center">¡Bienvenido a la bolsa de trabajo de ${platform.platformName.toUpperCase()}!</p>
           <br />
           <p style="font-size: 20px;">Ahora puedes acceder a ofertas laborales desde el sitio 
            ${platform.platformURL}, te recordamos que tus datos de acceso (correo electrónico y contraseña) 
            los estableciste al momento de registrarte. Mantenlos en un lugar seguro y no los compartas.</p>
           <br />
           <p style="font-size: 20px;">Este correo se envía una única vez como bienvenida al programa. 
           Conoce más en nuestro Aviso de privacidad publicado en la plataforma. Si tú no eres el 
           destinatario, por favor, elimina el correo electrónico. ®.</p>
           <br />
           <p style="font-size: 20px; font-weight: 600;">Te deseamos mucho éxito.</p>
           <br /> 
           <img width="160px" src="https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29" />
           <br />
           <p style="font-size: 14px;">¿Ya nos sigues?</p>
           <br />
           <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
               <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
           </a>
           <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
               <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
           </a>
           <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
               <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
           </a>
           <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
               <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
           </a>`,
        };

  const bodyMailRejected = (name, destiny) =>
    platform.customEmails
      ? {
          fromEmail: `${platform.fromEmail}`,
          destiny: `${destiny}`,
          subject: `${name} tenemos un error para registrar tu usuario - Bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${name}</p>
            <br />
            <p style="font-size: 20px;">No hemos podido verificar la autenticidad de tu usuario como 
            estudiante de ${platform.platformName}</p>
            <br />
            <p style="font-size: 20px; font-weight: 600;">Contacta al administrador de la bolsa de 
            trabajo para solicitar que apruebe tu acceso o te registre manualmente:
            </p>
            <br />
            <p style="font-size: 18px; color: blue; font-weight: 600;">${platform.platformContact}</p>
            <br />
            <p style="font-size: 14px;">¿Ya nos sigues?</p>
            <br />
            ${
              platform.facebookLink &&
              `<a styles="margin: 7px" href=${platform.facebookLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                </a>`
            }
            ${
              platform.twitterLink &&
              `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
            }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
           `,
        }
      : {
          destiny: `${destiny}`,
          subject: `${name} tenemos un error para registrar tu usuario - Bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${name}</p>
            <br />
            <p style="font-size: 20px;">No hemos podido verificar la autenticidad de tu usuario como 
            estudiante de ${platform.platformName}</p>
            <br />
            <p style="font-size: 20px; font-weight: 600;">Contacta al administrador de la bolsa de 
            trabajo para solicitar que apruebe tu acceso o te registre manualmente:
            </p>
            <br />
            <p style="font-size: 18px; color: blue; font-weight: 600;">${platform.platformContact}</p>
            <br />
            <p style="font-size: 14px;">¿Ya nos sigues?</p>
            <br />
            <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
            </a>
            <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
                <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
            </a>
            <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
            </a>
            <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
            </a>
            `,
        };

  const handleUser = async (data, action) => {
    setLoading(true);
    const newStatus = action ? 'authorized' : 'rejected';
    if (action) {
      const sendable = {
        email: data.email,
        type: 'student',
        segment: platform.platformName.toLowerCase(),
        status: 'authorized',
      };
      const sendableEmail = bodyMailAccepted(data.names, data.email);
      const request = await fetchDataPostAsync('authorizeUser', sendable);

      if (request.code) {
        setState((prevState) => ({ ...prevState, openAlert: true, message: 'Algo salio mal, intentalo mas tarde' }));
        toast.error('Algo salio mal, intentalo más tarde');
      } else {
        const requestEmail = await fetchDataPostAsync('sendEmailHTML', sendableEmail);
        if (requestEmail.code) {
          setState((prevState) => ({ ...prevState, openAlert: true, message: 'No se pudo notificar al usuario' }));
          toast.error('No se pudo notificar al usuario');
        }
        const newValues = users.find((user) => data.id === user.id);
        newValues.status = newStatus;
        await database
          .collection(`${platform.platformName}/data/users`)
          .doc(`${data.id}`)
          .set({ status: newStatus, authTime: dayjs().valueOf() }, { merge: true });
        const inc = firebase.firestore.FieldValue.increment(1);
        await database.collection(`${platform.platformName}`).doc('data').update({ usersCount: inc });
        dispatch(acceptUser(newValues));
        // TODO: Este setTime Out no sé exactamente porque.
        setTimeout(() => {
          getData();
          setState((prevState) => ({ ...prevState, openAlert: true, message: 'La cuenta fue autorizada' }));
          toast.success('La cuenta fue autorizada');
        }, 1000);
      }
      setLoading(false);
    } else {
      const sendable = { email: data.email };
      const sendableEmail = bodyMailRejected(data.names, data.email);
      const request = await fetchDataPostAsync('rejectUser', sendable);
      if (request.code) {
        setState((prevState) => ({ ...prevState, openAlert: true, message: 'Algo salio mal, intentalo más tarde' }));
        toast.error('Algo salio mal, intentalo más tarde');
      } else {
        const requestEmail = await fetchDataPostAsync('sendEmailHTML', sendableEmail);
        if (requestEmail.code) {
          setState((prevState) => ({ ...prevState, openAlert: true, message: 'No se pudo notificar al usuario' }));
          toast.error('No se pudo notificar al usuario');
        }
        const newValues = users.find((user) => data.id === user.id);
        newValues.status = newStatus;
        await database.collection(`${platform.platformName}/data/users`).doc(`${data.id}`).delete();
        dispatch(acceptUser(newValues));
        // TODO: Este setTime Out no sé exactamente porque.
        setTimeout(() => {
          getData();
          setState((prevState) => ({ ...prevState, openAlert: true, message: 'La cuenta fue rechazada' }));
          toast.error('La cuenta fue rechazada');
        }, 1000);
      }
      setLoading(false);
    }
  };

  const navigation = (event, newValue) => {
    setState((prevState) => ({
      ...prevState,
      CurrentTable: newValue,
    }));
  };

  const rejectVacancy = async (data) => {
    setLoading(true);
    const date = dayjs().valueOf();
    const permission = 'deny';
    const newValues = state.vacancies.filter((job) => data.jobID === job.jobID);
    newValues[0].Permission = permission;
    newValues[0].applicantsCount = 0;
    newValues[0].postedFrom = date;
    if (data.ATS) {
      await database
        .collection(`${platform.platformName}/data/vacancies`)
        .doc(data.jobID)
        .update({ Permission: permission, postedFrom: date, applicantsCount: 0 });
      dispatch(manageVacancy(newValues));
      if (!multiAccept.length) {
        setState((prevState) => ({ ...prevState, openAlert: true, message: 'Se rechazó la vacante' }));
        toast.error('Se rechazó la vacante');
      }
    } else {
      await database
        .collection(`${platform.platformName}/data/companies`)
        .doc(`${data.vacancyOwner}/jobs/${data.jobID}`)
        .update({ Permission: permission, postedFrom: date, applicantsCount: 0 });
      await database
        .collection(`${platform.platformName}/data/vacancies`)
        .doc(data.jobID)
        .update({ Permission: permission, postedFrom: date, applicantsCount: 0 });
      dispatch(manageVacancy(newValues));
      toast.error('Se rechazó la vacante');
      if (multiAccept.length) {
        setState((prevState) => ({ ...prevState, openAlert: true, message: 'Se rechazó la vacante' }));
        toast.error('Se rechazó la vacante');
      }
    }
    setState((prevState) => ({ ...prevState, loadVacancies: true }));
    setLoading(false);
  };

  const sendConfirmation = async (data) => {
    const sendable = {
      vacancyName: data.name,
      email: data.email,
      company: data.companyName,
      platformName: platform.platformFullName,
    };
    await fetchDataPostAsync('vacancyCompanyAcceptMail', sendable);
  };

  const acceptVacancy = async (data) => {
    setLoading(true);
    const date = dayjs().valueOf();
    const permission = 'accept';
    const newValues = state.vacancies.filter((job) => data.jobID === job.jobID);
    newValues[0].Permission = permission;
    newValues[0].applicantsCount = 0;
    newValues[0].postedFrom = date;

    if (data.ATS) {
      await database
        .collection(`${platform.platformName}/data/vacancies`)
        .doc(data.jobID)
        .update({ Permission: permission, postedFrom: date, applicantsCount: 0 });
      const inc = firebase.firestore.FieldValue.increment(1);
      await database.collection(`${platform.platformName}`).doc('data').update({ atsVacanciesCount: inc });
      dispatch(manageVacancy(newValues));
      if (!loader.active) {
        setState((prevState) => ({ ...prevState, openAlert: true, message: 'Se aprobó la vacante' }));
        toast.success('Se aprobó la vacante');
      }
      console.log('Subir a Elastic desde ATS');
      // Subir a elastic
      const {
        jobID,
        workType,
        companyName,
        ATS,
        img,
        jobTitle,
        logo,
        locationName,
        createdAt,
        carrer,
        seniority,
        campus,
        remoto,
        Permission,
        vacancyOwner,
      } = newValues[0];
      let category = [];

      if (newValues[0]?.category) {
        // eslint-disable-next-line no-nested-ternary
        category = Array.isArray(newValues[0]?.category)
          ? newValues[0]?.category?.map((cat) => cat.label)
          : typeof newValues[0]?.category === 'object'
          ? newValues[0]?.category?.label
          : newValues[0]?.category;
      }
      await setDocumenteElastic({
        action: 'save',
        index: production ? 'jobsindex' : 'jobsindexdev',
        data: {
          jobID,
          category,
          workType,
          companyName,
          ATS,
          img,
          jobTitle,
          logo,
          locationName,
          createdAt,
          carrer,
          seniority,
          campus,
          remoto,
          vacancyOwner,
          Permission: Permission || 'accept',
          uniOwner: platform.platformName,
          objectID: newValues[0].jobID,
        },
      });
    } else {
      await database
        .collection(`${platform.platformName}/data/companies`)
        .doc(`${data.vacancyOwner}/jobs/${data.jobID}`)
        .update({ Permission: permission, postedFrom: date, applicantsCount: 0 });
      await database
        .collection(`${platform.platformName}/data/vacancies`)
        .doc(data.jobID)
        .update({ Permission: permission, postedFrom: date, applicantsCount: 0 });
      const inc = firebase.firestore.FieldValue.increment(1);
      await database.collection(`${platform.platformName}`).doc('data').update({ vacanciesCount: inc });
      await database
        .collection(`${platform.platformName}`)
        .doc('data')
        .collection('companies')
        .doc(data.vacancyOwner)
        .update({ vacanciesCount: inc });
      const company = (
        await database.collection(`${platform.platformName}/data/companies/`).doc(data.vacancyOwner).get()
      ).data();
      await sendConfirmation({
        name: data.jobTitle,
        email: [company.companyEmail],
        companyName: company.companyName,
      });
      dispatch(manageVacancy(newValues));
      if (!loader.active) {
        setState((prevState) => ({ ...prevState, openAlert: true, message: 'Se aprobó la vacante' }));
        toast.success('Se aprobó la vacante');
      }
      const {
        jobID,
        workType,
        companyName,
        ATS,
        img,
        jobTitle,
        logo,
        locationName,
        createdAt,
        carrer,
        seniority,
        campus,
        remoto,
        Permission,
        vacancyOwner,
      } = newValues[0];

      let category = [];

      if (newValues[0]?.category) {
        // eslint-disable-next-line no-nested-ternary
        category = Array.isArray(newValues[0]?.category)
          ? newValues[0]?.category?.map((cat) => cat.label)
          : typeof newValues[0]?.category === 'object'
          ? newValues[0]?.category?.label
          : newValues[0]?.category;
      }

      console.log('Subir a Elastic desde Normal;');
      // Subir a elastic
      await setDocumenteElastic({
        action: 'save',
        index: production ? 'jobsindex' : 'jobsindexdev',
        data: {
          jobID,
          category,
          workType,
          companyName,
          ATS,
          img,
          jobTitle,
          logo,
          locationName,
          createdAt,
          carrer,
          seniority,
          campus,
          remoto,
          vacancyOwner,
          Permission: Permission || 'accept',
          uniOwner: platform.platformName,
          objectID: newValues[0].jobID,
        },
      });
    }
    NotificationManager.success('Se guardo correctamente, se mostrara en la página principal');
    setState((prevState) => ({ ...prevState, loadVacancies: true }));
    setLoading(false);
  };

  const bodyMailNotification = (destiny, name, adminName) =>
    platform.customEmails
      ? {
          fromEmail: `${platform.fromEmail}`,
          destiny: `${destiny}`,
          subject: `${name} registro exitoso para la bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${adminName},</p>
            <br />
            <p style="font-size: 18px;">Tu cuenta fue autorizada por uno de nuestros administradores.</p>
            <br />
            <p style="font-size: 18px;">Ya puedes publicar vacantes ilimitadas accediendo al
             portal ${
               platform.platformURL
             } con el usuario <strong>${destiny}. (El login para empresas está abajo a la derecha)</p>
             <br />
             <p style="font-size: 18px;">Si tiene dudas sobre el uso o la plataforma puedes contactarte
              con el administrador: ${platform.platformContact}.</p>
            <br />
             <p style="font-size: 18px;">Te deseamos mucho éxito y esperamos encuentres 
             colaboradores que encajen con tu compañía.</p>
             <br />
           <img width="160px" src=${platform.customEmailsLogo} />
           <br />
           <p style="font-size: 14px;">¿Ya nos sigues?</p>
           <br />
           ${
             platform.facebookLink &&
             `<a styles="margin: 7px" href=${platform.facebookLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                </a>`
           }
           ${
             platform.twitterLink &&
             `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
           }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
            `,
        }
      : {
          destiny: `${destiny}`,
          subject: `${name} registro exitoso para la bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${adminName},</p>
            <br />
            <p style="font-size: 18px;">Tu cuenta fue autorizada por uno de nuestros administradores.</p>
            <br />
            <p style="font-size: 18px;">Ya puedes publicar vacantes ilimitadas accediendo al
             portal ${platform.platformURL} con el usuario <strong>${destiny}. (El login para empresas está abajo a la derecha)</p>
             <br />
             <p style="font-size: 18px;">Si tiene dudas sobre el uso o la plataforma puedes contactarte
              con el administrador: ${platform.platformContact}.</p>
            <br />
             <p style="font-size: 18px;">Te deseamos mucho éxito y esperamos encuentres 
             colaboradores que encajen con tu compañía.</p>
             <br />
            <img width="140px" src="https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29" />
            <br />
            <p style="font-size: 14px;">¿Ya nos sigues?</p>
            <br />
            <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
            </a>
            <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
                <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
            </a>
            <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
            </a>
            <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
            </a>`,
        };

  const bodyMailNotificationReject = (destiny, name, adminName) =>
    platform.customEmails
      ? {
          fromEmail: `${platform.fromEmail}`,
          destiny: `${destiny}`,
          subject: `${name} no se pudo autorizar el registro para la bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${adminName},</p>
            <br />
            <p style="font-size: 18px;">Te informamos que la solicitud de registro de la cuenta fue rechazada por uno de nuestros administradores.</p>
            <br />
             <p style="font-size: 18px;">Si tiene dudas sobre el motivo de rechazo puedes contactarte
              con el administrador: ${platform.platformContact}.</p>
            <br />
            <img width="160px" src=${platform.customEmailsLogo} />
           <br />
           <p style="font-size: 14px;">¿Ya nos sigues?</p>
           <br />
           ${
             platform.facebookLink &&
             `<a styles="margin: 7px" href=${platform.facebookLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                </a>`
           }
           ${
             platform.twitterLink &&
             `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
           }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
            `,
        }
      : {
          destiny: `${destiny}`,
          subject: `${name} no se pudo autorizar el registro para la bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${adminName},</p>
            <br />
            <p style="font-size: 18px;">Te informamos que la solicitud de registro de la cuenta fue rechazada por uno de nuestros administradores.</p>
            <br />
             <p style="font-size: 18px;">Si tiene dudas sobre el motivo de rechazo puedes contactarte
              con el administrador: ${platform.platformContact}.</p>
            <br />
            <img width="140px" src="hhttps://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29" />
            <br />
            <p style="font-size: 14px;">¿Ya nos sigues?</p>
            <br />
            <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
            </a>
            <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
                <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
            </a>
            <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
            </a>
            <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
            </a>`,
        };

  const updateCompany = async (data, action) => {
    setLoading(true);
    if (action) {
      const currentCompanies = state.companies;
      const found = state.companies.findIndex((element) => element === data);
      currentCompanies.splice(found, 1);
      const inc = firebase.firestore.FieldValue.increment(1);
      await database
        .collection(`${platform.platformName}/data/companies`)
        .doc(data.objectID)
        .update({ active: true, authTime: dayjs().valueOf() });
      await database.collection(`${platform.platformName}`).doc('data').update({ companiesCount: inc });
      const sendable = bodyMailNotification(data.companyEmail, data.companyName, data.adminName);
      await fetchDataPostAsync('sendEmailHTML', sendable);
      dispatch(setCompanies(currentCompanies));
      setState((prevState) => ({ ...prevState, openAlert: true, message: 'Se aprobó la cuenta' }));
      toast.success('Se aprobó la cuenta');
      setLoading(false);
    } else {
      const currentCompanies = state.companies;
      const found = state.companies.findIndex((element) => element === data);
      currentCompanies.splice(found, 1);
      await database.collection(`${platform.platformName}/data/companies`).doc(data.objectID).delete();
      const sendable = { email: data.companyEmail };
      await fetchDataPostAsync('rejectUser', sendable);
      setState((prevState) => ({ ...prevState, companies: currentCompanies }));
      dispatch(setCompanies(currentCompanies));
      setState((prevState) => ({
        ...prevState,
        openAlert: true,
        message: 'Se rechazó la cuenta de manera correcta',
      }));
      toast.success('Se rechazó la cuenta de manera correcta');
      const sendableEmail = bodyMailNotificationReject(data.companyEmail, data.companyName, data.adminName);
      await fetchDataPostAsync('sendEmailHTML', sendableEmail);
      setLoading(false);
    }
  };

  const multiAcceptAction = () => {
    setLoader({ active: true, action: 'accept' });
  };

  const multiRejectAction = () => {
    setLoader({ active: true, action: 'reject' });
  };

  const effectAccept = async () => {
    if (loader.active && loader.action === 'accept') {
      // eslint-disable-next-line no-restricted-syntax
      for await (const m of multiAccept) {
        if (state.CurrentTable === 'student') {
          await handleUser(m, true);
        } else if (state.CurrentTable === 'vacancy') {
          await acceptVacancy(m);
        } else {
          await updateCompany(m, true);
        }
      }
      setState((prevState) => ({
        ...prevState,
        message: 'Se completo la acción',
        openAlert: true,
      }));
      toast.success('Se completo la acción');
      setLoader({ active: false, action: '' });
      setMultiAccept([]);
    }
  };

  const effectReject = async () => {
    if (loader.active && loader.action === 'reject') {
      // eslint-disable-next-line no-restricted-syntax
      for await (const m of multiAccept) {
        if (state.CurrentTable === 'student') {
          await handleUser(m, false);
        } else if (state.CurrentTable === 'vacancy') {
          await rejectVacancy(m);
        } else {
          await updateCompany(m, false);
        }
      }
      setState((prevState) => ({
        ...prevState,
        message: 'Se completo la acción',
        openAlert: true,
      }));
      toast.success('Se completo la acción');
      setLoader({ active: false, action: '' });
      setMultiAccept([]);
    }
  };

  React.useEffect(() => onLoadMain(), []);

  React.useEffect(() => {
    getData();
    effectAccept();
    effectReject();
  }, [vacancies, users, loader, state.loadVacancies]);

  return (
    <MainStyled adminColor={platform?.adminColor}>
      <div className="graphicsSide">
        <div className="welcomePage">
          <div className="welcomeTextContainer">
            <h1>
              <span className="golden">Bienvenid@ de nuevo!</span>
            </h1>
            <button
              type="button"
              className="special-open"
              style={{
                right: drawer ? 450 : -32,
                transform: `${drawer ? 'rotate(180deg)' : 'rotate(0deg)'}`,
              }}
              onClick={() => toggleDrawer(drawer)}>
              <ChevronLeft size={24} color="#fff" />
            </button>
            {state.vacancies.length === 0 && state.companies.length === 0 && state.users.length === 0 ? (
              <p>
                No hay <span className="golden">nada</span> de nuevo
              </p>
            ) : (
              <p>
                Tenemos <span className="golden">algunas cosas</span> pendientes
              </p>
            )}
            <ul>
              {state.vacancies.length > 0 && (
                <li>
                  Tienes <b className="golden">{state.vacancies.length}</b> nueva(s) solicitude(s) de vacantes
                  pendientes
                </li>
              )}
              {state.companies.length > 0 && (
                <li>
                  Tienes <b className="golden">{state.companies.length}</b> nueva(s) solicitude(s) de empresas
                  pendientes
                </li>
              )}
              {state.users.length > 0 && (
                <li>
                  Tienes <b className="golden">{state.users.length}</b> nueva(s) solicitude(s) de{' '}
                  {platform.userTypeText} pendientes
                </li>
              )}
            </ul>
          </div>
          <div className="welcomeImageContainer">
            <img
              src="https://lapieza-unis-admin-test.s3.us-west-1.amazonaws.com/static/media/balloon.c9d6342e.png"
              alt={`Bolsa de trabajo de ${platform.platformFullName}`}
            />
          </div>
        </div>
        <section style={{ marginTop: -100, zIndex: 99 }}>
          <CompaniesDashboard />
        </section>
        <section>
          <VacanciesDashboard />
        </section>
        <section>
          <UsersDashboard />
        </section>
      </div>

      <Drawer anchor="right" open={drawer} onClose={() => setDrawer(false)} variant="persistent">
        <div className="tablesNav">
          <Tabs value={state.CurrentTable} onChange={navigation}>
            <Tab label="Estudiantes" value="student" />
            <Tab label="Vacantes" value="vacancy" />
            <Tab label="Empresas" value="company" />
          </Tabs>

          {/* <p */}
          {/*  className={state.CurrentTable === 'student' ? 'tableNavItemActive' : 'tableNavItem'} */}
          {/*  onClick={() => navigation('student')}> */}
          {/*  Estudiantes */}
          {/* </p> */}
        </div>
        <div className="tableContainer">
          <div className="tableOptions">
            {multiAccept.length > 0 ? (
              <p className="acceptAll" onClick={multiAcceptAction}>
                Aceptar <Done size={20} color="#000" />
              </p>
            ) : null}
            {multiAccept.length > 0 ? (
              <p className="denyAll" onClick={multiRejectAction}>
                Rechazar <Close size={20} color="#000" />
              </p>
            ) : null}
            <div className="toggleOptions">
              <p>Más opciones</p>
              <button type="button" onClick={handleClick}>
                <MoreVertical size={20} color="#fff" />
              </button>
              <Popup id="long-menu" anchor={anchorEl} show={open} onClose={handleClose} style={{ zIndex: 9999 }}>
                <button type="button" onClick={selectAll}>
                  Seleccionar todos
                </button>
                <button type="button" onClick={removeAll}>
                  Quitar selección
                </button>
              </Popup>
            </div>
          </div>

          {state.CurrentTable === 'student' ? (
            <div className="tableContent">
              {!loading ? (
                state.users.map((item, index) => {
                  return (
                    <UserCard
                      key={index.toString()}
                      userInfo={item}
                      userAction={handleUser}
                      showMore={showMore}
                      addMulti={setMultiAccept}
                      store={multiAccept}
                      isSelected={multiAccept.indexOf(item) !== -1}
                    />
                  );
                })
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: '16px' }}>
                  <CircularProgress />
                </Box>
              )}
              {state.users.length === 0 ? (
                <>
                  <img src={notfound} className="notfound" alt="" />
                  <p className="validationMessage">No hay solicitudes de usuarios actualmente</p>{' '}
                </>
              ) : null}
            </div>
          ) : null}
          {state.CurrentTable === 'vacancy' ? (
            <div className="tableContent">
              {!loading ? (
                state.vacancies.map((item, index) => {
                  return (
                    <VacancyCard
                      key={index.toString()}
                      data={item}
                      accept={acceptVacancy}
                      reject={rejectVacancy}
                      showMore={showMore}
                      addMulti={setMultiAccept}
                      store={multiAccept}
                      isSelected={multiAccept.indexOf(item) !== -1}
                    />
                  );
                })
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: '16px' }}>
                  <CircularProgress />
                </Box>
              )}
              {state.vacancies.length === 0 ? (
                <>
                  <img src={notfound} className="notfound" alt="" />
                  <p className="validationMessage">No hay solicitudes de vacantes actualmente</p>
                </>
              ) : null}
            </div>
          ) : null}
          {state.CurrentTable === 'company' ? (
            <div className="tableContent">
              {!loading ? (
                state.companies.map((item, index) => {
                  return (
                    <CompanyCard
                      key={index.toString()}
                      data={item}
                      handleCompany={updateCompany}
                      showMore={showMore}
                      addMulti={setMultiAccept}
                      store={multiAccept}
                      isSelected={multiAccept.indexOf(item) !== -1}
                    />
                  );
                })
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: '16px' }}>
                  <CircularProgress />
                </Box>
              )}
              {state.companies.length === 0 ? (
                <>
                  <img src={notfound} className="notfound" alt="" />
                  <p className="validationMessage">No hay solicitudes de empresas actualmente</p>
                </>
              ) : null}
            </div>
          ) : null}
        </div>
        <JobDetailModal
          data={state.currentVacancy}
          open={state.showVacancyModal}
          close={() => ToggleModal('showVacancyModal')}
        />
        <UserDetailModal
          data={state.currentUser}
          open={state.showUserModal}
          close={() => ToggleModal('showUserModal')}
        />
        <CompanyModal
          open={state.showCompanyModal}
          close={() => ToggleModal('showCompanyModal')}
          data={state.currentCompany}
          id={state.currentCompany.objectID}
        />
      </Drawer>
      {loader.active ? (
        <Dialog title="Recuperar cuenta">
          <div>
            <PuffLoader size={80} color={palette.accept} />
            <p>Procesando ...</p>
          </div>
        </Dialog>
      ) : null}
    </MainStyled>
  );
};

export default MainDashboard;
